import { createSlice } from "@reduxjs/toolkit";
import { makeThunk } from "helpers/makeThunk";
import { handleCommonCases } from "helpers/thunkHandler";
import {
  FORGOT_PASSWORD_RESET,
  FORGOT_PASSWORD_SEND_EMAIL,
  FORGOT_PASSWORD_VERIFY_OTP,
  GET_DETAILS,
  LOGIN,
  SET_PASSWORD,
  VERIFY_INVITE,
  CHANGE_PASSWORD,
  EDIT_PROFILE
} from "helpers/url_helper";

// THUNK: Login User

export const loginUser = makeThunk({
  url: LOGIN,
});
export const getDetails = makeThunk({ url: GET_DETAILS, method: "get" });
export const setPassword = makeThunk({ url: SET_PASSWORD });
export const verifyInvite = makeThunk({
  url: (token) => `${VERIFY_INVITE}?token=${token}`,
  type: (token) => `${VERIFY_INVITE}/${token}`,
  method: "get",
});
export const forgotPasswordSendEmail = makeThunk({
  url: FORGOT_PASSWORD_SEND_EMAIL,
});
export const forgotPasswordVerifyEmailOTP = makeThunk({
  url: FORGOT_PASSWORD_VERIFY_OTP,
});
export const forgotPasswordSetNewPassword = makeThunk({
  url: FORGOT_PASSWORD_RESET,
  method: "patch",
});
export const changePassword = makeThunk({
  url: CHANGE_PASSWORD,
  method: "put",
});
export const editProfile = makeThunk({
  url: EDIT_PROFILE,
  method: "put",
});

const initialState = {
  authUser: JSON.parse(localStorage.getItem("authUser")) || null,
  isLoggedIn: !!localStorage.getItem("authToken"),
  isLoading: false,
  isGettingDetails: true,
  accountType: null,
  rolePermissions: {},
  authUserDetails: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    logout: (state) => {
      state.authUser = null;
      state.token = null;
      state.isAuthenticated = false;

      localStorage.removeItem("authUser");
      localStorage.removeItem("authToken");
    },
  },

  extraReducers: (builder) => {
    handleCommonCases(builder, loginUser, {
      loadingKey: "isLoading",
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        const { accountType } = data || {};
        state.accountType = accountType;
        state.isLoggedIn = true;
        state.authUser = data || {};
        localStorage.setItem("authUser", JSON.stringify(data));
      },
    });

    handleCommonCases(builder, getDetails, {
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        const { roleId, accountType } = data || {};
        state.authUserDetails = data || {};
        state.rolePermissions = roleId || {};
        state.accountType = accountType;
      },
    });

    handleCommonCases(builder, verifyInvite, {
      loadingKey: "isLoading",
    });
    handleCommonCases(builder, setPassword, {
      loadingKey: "isLoading",
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        const { accountType } = data || {};
        state.isLoggedIn = true;
        state.accountType = accountType;
        state.authUser = data || {};
        localStorage.setItem("authUser", JSON.stringify(data));
      },
    });
    handleCommonCases(builder, forgotPasswordSendEmail, {
      loadingKey: "isLoading",
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
      },
    });
    handleCommonCases(builder, changePassword, {
      loadingKey: "isLoading",
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
      },
    });
    handleCommonCases(builder, editProfile, {
      loadingKey: "isLoading",
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
      },
    });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
